import { userInfoFrag } from '../../../../../utils/type/user.common-type';
import { serviceUserFrag } from '../../../../../services/types/user.types';

export const getSequenceNumberFrag = `
    workData {
        ... on WorkDataSuggestionObject {
            sequenceNumber
        }
    }
`;

export const getFolderByPersonFrag = `
    id
    status
    disposalState
`;

export const getFolderFrag = `
    id
    serviceAddressId
    status
    closedAt
    disposalState
    workplaces {
        workplaceId
        dateFrom
        dateTo
    }
`;

export const getWorkDetailFrag = `
    id
    workType
    serviceId
    dateFrom
    dateTo
    folderId
    users {
        id
    }
    files {
        fileId
        name
        path
    }
    workData {
        ... on WorkDataSuggestionObject {
            id
            type
            sequenceNumber
            description
            note
            complaintTypeId
            priority
        }
    }
    person {
        id
    }
`;

export const getEvaluationsFrag = `
    id
    savedById
    savedBy {
        ${userInfoFrag}
    }
    evaluationDate
    onlyForWorker
`

export const getEvaluationDetailFrag = `
    id
    state
    onlyForWorker
    evaluation
    evaluationDate
    evaluatorId
    offerId
    applications
    savedById
    clientPresence
`

export const getWorkSplitCopyFrag = `
    id
    workType
    serviceId
    dateFrom
    dateTo
    folderId
    users {
        ${serviceUserFrag}
    }
    files {
        fileId
        name
        path
    }
    workData {
        ... on WorkDataSuggestionObject {
            id
            type
            sequenceNumber
            description
            note
            complaintTypeId
            priority
            lastEvaluation {
                ${getEvaluationDetailFrag}
            }
        }
    }
    person {
        id
        titleBeforeName
        titleAfterName
        name
        surname
    }
`;

export const getUsersFrag = `
    ${userInfoFrag}
`;
